import React, { Component } from 'react';
import CustomCheckbox from './CustomCheckbox';

export default class SelectIntermediateLabels extends Component {

  render() {
    let center = {textAlign: 'center'},
        selectAll = {
          display: 'flex',
          alignItems: 'center',
          marginBottom: '15px',
          border: '1px solid #dbdee0',
          marginTop: '1.5rem',
          paddingLeft: '0px',
        },
        selectAllCheckbox = {
          display: 'flex',
          justifyContent: 'center',
          width: '10%',
        }
    return(
      <div>
        <table className="table table-stripped table-hover datatable mb-0">
          <thead className="thead-inverse">
            <tr>
              <th style={center}>Print</th>
              <th style={center}>Name</th>
              <th style={center}>Qty</th>
              <th style={center}>Pieces</th>
            </tr>
          </thead>
          <tbody>
          {this.props.items.map((item,index) => {
            let selectedRow = item.selected ? {background: 'rgb(230, 230, 230)'} : {},
                checkboxCell = {width: '10%', padding: '0px', textAlign: 'center', verticalAlign: 'middle'},
                tableCell = {border: '1px solid #e9ebec', textAlign:'center'};
            return (
              <tr key={index} style={selectedRow}>
                <td style={checkboxCell}>
                  <CustomCheckbox index={index} selected={item.selected} toggleCheckBox={this.props.toggleCheckBox}/>
                </td>
                <td style={tableCell}>{item.item.name}</td>
                <td style={tableCell}>{item.amount} {item.item.measure_unit || 'lb'}</td>
                <td style={tableCell}>{item.pieces || 1}</td>
              </tr>
            );
          })}
          </tbody>
        </table>
        {this.props.items.length === 0 ?
          <div className="empty-table"><span> There are no products to print </span></div>
          : null }
        {this.props.items.length > 1 ?
          <div className="card-header" style={selectAll}>
            <div className="mr-1" style={selectAllCheckbox}>
              <CustomCheckbox selected={this.props.allSelected} toggleCheckBox={this.props.selectAll}/>
            </div>
            <span> Select All</span>
          </div>
          : null}
      </div>
    )
  }
}
